<script>
export default {
    props: {
        data: Object,
    },
    methods: {
        updateBid(data){
            this.$emit('updateBid', data)
        },
        checkDateAndDisplay(date) {
            let dateVal = new Date(date);
            if (dateVal.getFullYear() < 2000) return "-";
            return this.formatDateWithTime(new Date(date));
        },
    }
}
</script>
<template>
    <div>
        <div class="d-flex mb-3 flex-row-reverse">
            <a href="javascript:void(0);" @click="updateBid(data)">
                <div class="d-flex align-items-center">
                    [<i class="bx bx-edit"></i>Update Details]
                </div>
            </a>
        </div>
        <table class="table table-bordered table-striped">
            <tbody>
                <tr>
                    <td class="w-50">
                        PR Number:
                    </td>
                    <td>
                        <span class="text-yellow">{{data.prNumber}}</span>
                    </td>
                </tr>
                <tr>
                    <td class="w-50">
                        PR Description:
                    </td>
                    <td>
                        <span class="text-yellow">{{data.description}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Bid Number:
                    </td>
                    <td>
                        <span class="text-yellow">{{data.rfqNumber}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Date of Issue:
                    </td>
                    <td>
                        <span class="text-yellow">{{ checkDateAndDisplay(data.bidOpeningDate) }}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Bid Docs Available Date:
                    </td>
                    <td>
                        <span class="text-yellow">{{ checkDateAndDisplay(data.bidDocsAvailableDate)}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Bid Docs Amount:
                    </td>
                    <td>
                        <span class="text-yellow">{{ formatCurrency(data.bidDocsAmount) }}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Bid Docs Submission Deadline:
                    </td>
                    <td>
                        <span class="text-yellow">{{ checkDateAndDisplay(data.deadline) }}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Bid Security Valid Until:
                    </td>
                    <td>
                        <span class="text-yellow">{{ checkDateAndDisplay(data.bidSecurityValidUntil) }}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        SLCC Percentage Required:
                    </td>
                    <td>
                        <span class="text-yellow">{{data.slccPercentageRequired}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Subcontracting Allowed:
                    </td>
                    <td>
                        <span class="text-yellow">{{data.subContractingAllowed ? 'Yes' : 'No'}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Project Awarded As:
                    </td>
                    <td>
                        <span class="text-yellow">{{data.projectAwardedAs}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        Note:
                    </td>
                    <td>
                        {{data.note}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>